/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Translation_ModalInputs */



/**
* | output |
* | --- |
* | "Close Translation Modal" |
*
* @param {Close_Translation_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_translation_modal = /** @type {((inputs?: Close_Translation_ModalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Translation_ModalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la fenêtre de traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungsmodal schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi la finestra modale di traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть модальное окно перевода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar modal de traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("近译模态")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳モーダルを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar Modal de Tradução")
	return /** @type {LocalizedString} */ ("Close Translation Modal")
});